/**
 * customDropdown
 * 
 * Description: Allow for custom styling on dropdowns.
 * 
 */
document.addEventListener('alpine:init', () => {
    Alpine.data('customDropdown', () => ({
        open: false,
        selectedValue: '',
        selectedText: '',

        toggleDropdown() {
            this.open = !this.open;
        },

        selectOption(value, text) {
            const escapeHtml = (unsafe) => {
                const txt = document.createElement('textarea');
                txt.innerHTML = unsafe;
                return txt.value;
            }
            this.selectedValue = value;
            this.selectedText = escapeHtml(text); // Update the button text
            this.$refs.hiddenInput.value = value; // Update the form field
            this.open = false;
        },

        closeDropdown() {
            this.open = false;
        },
    }));
});
